import { useQuery } from '@tanstack/react-query'
import { crosspostingApi } from '~/entities/crossposting/api/crossposting-api'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'

export function useCrosspostingStatus(businessId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.CROSSPOST_STATUS, businessId),
    queryFn: () => crosspostingApi.getStatus(businessId),
    enabled: !!businessId,
    staleTime: 5 * 60_000,
  })
}
